import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

/**
 * Registers the meeting the coach is currently viewing on the Past Meetings
 * tab. Only the recording id and meeting date are surfaced — Lubav has a tool
 * for fetching transcript content on demand, so we don't dump the transcript
 * itself into context.
 */
export const useAgentContext = (
  selectedTranscript: { recordingId: number; meetingDate: string } | null,
) => {
  useRegisterAgentContext(
    selectedTranscript
      ? {
          kind: 'entity',
          description:
            "The coaching meeting transcript the user is currently viewing. Use the recording_id with the transcript-fetching tool when the user asks about this meeting's content.",
          data: {
            recording_id: selectedTranscript.recordingId,
            meeting_date: selectedTranscript.meetingDate,
          },
        }
      : null,
  );
};
